class Router {
    constructor(cb) {
        this.instance = null;
        this.cb = cb
    }

    static getInstance(cb) {
        if (!this.instance) {
            this.instance = new Router(cb);
            this.instance.listenRouteChange();
            return this.instance;
        }
        return this.instance;
    }

    listenRouteChange() {
        history.pushState = this.addHistoryMethod('pushState');
        history.replaceState = this.addHistoryMethod('replaceState');
    }

    addHistoryMethod(name) {
        if (name === 'pushState' || name === 'replaceState') {
            var method = history[name];
            return (...args) => {
                const nextURL = args[args.length - 1]
                const currentURL = `${window.location.pathname}${window.location.search}`
                // 判断跳转的 url 是否与当前 url 相同，如相同，可能只是修改 state 或者 next.js 框架在路由初始化时调用了 replaceState
                // 此时不调用任何回调函数
                if (nextURL && nextURL !== currentURL) {
                    for (var i = 0; i < this.cb.length; i++) {
                        this.cb[i]()
                    }
                }
                method.apply(history, args);
            }
        }
    }
}

function invokeCbs(cb) {
    for (var i = 0; i < cb.length; i++) {
        cb[i].apply(this);
    }
}

export default function (cb) {
    // browser router
    Router.getInstance(cb);

    window.addEventListener('popstate', function() {
        invokeCbs.call(this, cb)
    })

    //hash router
    window.addEventListener('hashchange', function () {
        invokeCbs.call(this, cb)
    });
}
